/* ============================================================
   JDM YARD — Phase 1 custom scripts (isolated)
   ============================================================ */

/* --- One-click add-to-cart on product cards (single-variant) --- */
(function () {
  'use strict';
  function addUrl() { return (window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js'; }
  function fireEvents(data) {
    try {
      ['cart:refresh', 'cart:updated', 'ajaxProduct:added', 'product:added', 'cart:build'].forEach(function (n) {
        document.dispatchEvent(new CustomEvent(n, { bubbles: true, detail: { cart: data, product: data } }));
      });
    } catch (e) {}
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-jdm-atc]');
    if (!btn) return;
    e.preventDefault();
    if (btn.classList.contains('is-loading') || btn.classList.contains('is-added')) return;
    var id = btn.getAttribute('data-jdm-atc');
    if (!id) return;
    var label = btn.querySelector('.jdm-atc-label');
    var prevText = label ? label.textContent : '';
    btn.classList.add('is-loading');
    var xhr = new XMLHttpRequest();
    xhr.open('POST', addUrl(), true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.setRequestHeader('Accept', 'application/json');
    xhr.onload = function () {
      btn.classList.remove('is-loading');
      if (xhr.status >= 200 && xhr.status < 300) {
        var data = {};
        try { data = JSON.parse(xhr.responseText); } catch (err) {}
        btn.classList.add('is-added');
        if (label) label.textContent = 'Added';
        fireEvents(data);
        setTimeout(function () { btn.classList.remove('is-added'); if (label) label.textContent = prevText; }, 1800);
      } else { window.location.href = '/cart'; }
    };
    xhr.onerror = function () { btn.classList.remove('is-loading'); window.location.href = '/cart'; };
    xhr.send(JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] }));
  });
})();

/* --- Inject per-product subheadline under the VISIBLE product title --- */
(function () {
  'use strict';
  function inject() {
    var sub = window.JDM_SUBHEADLINE;
    if (!sub) return;
    if (document.querySelector('.jdm-product-subheadline')) return;
    var titles = document.querySelectorAll('.product-single__title');
    var title = null;
    for (var i = 0; i < titles.length; i++) { if (titles[i].offsetParent !== null) { title = titles[i]; break; } }
    if (!title) title = titles[0];
    if (!title) return;
    var p = document.createElement('p');
    p.className = 'jdm-product-subheadline';
    p.textContent = sub;
    title.insertAdjacentElement('afterend', p);
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', inject); } else { inject(); }
})();

/* --- Move the Judge.me reviews section to the bottom of the PDP --- */
(function () {
  'use strict';
  if (!/\/products\//.test(location.pathname)) return;
  function moveReviews() {
    var main = document.querySelector('main.main-content') || document.getElementById('MainContent');
    if (!main) return;
    var widget = document.querySelector('.jdgm-rev-widg') || document.querySelector('.jdgm-all-reviews-rating');
    if (!widget) return;
    var section = widget.closest('.shopify-section');
    if (!section || section.parentElement !== main) return;
    if (section === main.lastElementChild) return;
    main.appendChild(section);
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', moveReviews); } else { moveReviews(); }
  setTimeout(moveReviews, 1000);
  setTimeout(moveReviews, 2500);
  setTimeout(moveReviews, 5000);
})();
